module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-45.f80af1d1.png";